<template>
  <div class="row mt-0 mt-lg-3">
    <div class="col-xl-3">
      <Card :card="card" titleLink="SocialEngineering" :seeMore="true" />
    </div>
    <div class="col-xl-9">
      <Tabs :tabs="tabs" :object="interaction" />
    </div>
  </div>
</template>

<script>
import Card from "@/components/profile/Card.component";
import Tabs from "@/components/training/Tabs.component";

import { getStakeholderActions } from "@/api/traits.api";

import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "SocialEngineering",
  props: {
    interaction: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tabs: [],
      object: {},
      wellbeing: 0
    };
  },
  components: {
    Card,
    Tabs
  },
  computed: {
    ...mapGetters("Constants", ["getConstant"]),
    card() {
      return {
        progress: false,
        color: this.interaction.color || "tc4",
        image: this.interaction.image || "share.svg",
        title: this.$t("messages.generic.modules.social.title"),
        description: this.$t("messages.generic.modules.social.description")
      };
    }
  },
  methods: {},
  mounted() {
    var params = {
      surveyTypes: [this.interaction.surveyTypeId],
      groupDimensions: [this.getConstant("DIMENSION_GROUP_SOCIAL_ENGINEERING")],
      actionTypes: [
        this.getConstant("ACTIONS_TYPE_SE_TYPE_RECOM"),
        this.getConstant("ACTIONS_TYPE_SE_RECOMENDATION"),
        this.getConstant("ACTIONS_TYPE_SE_GENERAL")
      ],
      entityType: this.getConstant("ENTITY_TYPE_USER"),
      maxValue: "NO",
      surveyEntities: [this.interaction.surveyEntityId]
    };
    getStakeholderActions(localStorage.getItem("stakeholderId"), params).then(
      resp => {
        var tabs = resp.data.records;
        _.each(tabs, tab => {
          switch (parseInt(tab.actionTypeId)) {
            case parseInt(this.getConstant("ACTIONS_TYPE_SE_TYPE_RECOM")):
              tab.order = 0;
              break;
            case parseInt(this.getConstant("ACTIONS_TYPE_SE_RECOMENDATION")):
              tab.order = 1;
              break;
            case parseInt(this.getConstant("ACTIONS_TYPE_SE_GENERAL")):
              tab.order = 2;
              break;
            default:
              tab.order = 0;
          }
        });
        this.tabs = _.orderBy(tabs, "order");
      }
    );
  }
};
</script>
